module.exports = __webpack_public_path__ + "static/media/lumps.a58717b5.PNG";